import { render } from "./PokemonPicture.vue?vue&type=template&id=71b2793c&scoped=true"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=71b2793c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LF\\Desktop\\Vue\\pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b2793c"]])

export default __exports__